import styled from 'styled-components';
import { color } from '../../theme/Color';

interface kpiContainerProps {
  themeMode: string;
}

export const KPIMetricsForTwoContainer = styled.div<kpiContainerProps>`
  ont-family: 'Inter';
  font-weight: 400;
  margin-left: -20px;

  & .scorecardContainer {
    margin-bottom: -24px;
  }

  & .metricsItem {
    padding-left: 20px;
    padding-top: 10px;
    padding-bottom: 5px;
  }

  & .metricsBlock {
    margin-bottom: 24px;
    display: flex;
    flex-wrap: nowrap;
  }

  & .metricsDivider {
    border-width: 1px;
    background: ${({ themeMode }) =>
      themeMode === 'light' ? color._B2CAEA : color._3a3a3a};
    height: 100%;
  }

  & .metricsData {
    font-size: 16px;
    font-weight: 700;
    font-family: 'Inter';
    line-height: 22px;
    color: ${({ themeMode }) =>
      themeMode === 'light' ? `${color._616161}` : `${color._efefef} `};
  }

  & .metricsText {
    font-size: 14px;
    color: ${({ themeMode }) =>
      themeMode === 'light' ? color._616161 : color._d0d0d0};
    font-family: Inter;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    text-transform: capitalize;
  }
`;
